export default class DatasheetSummary {

	constructor() {

		$("#sitewide-overlay, #ds-summary-dialog .close, #ds-summary-dialog .done")
			.on("click", () => $("#ds-summary-dialog, #sitewide-overlay").fadeOut())

		this.renderSummaryDescriptionViewMoreLink()
	}

	private renderSummaryDescriptionViewMoreLink() {
		let dsSummary = $(".product-summary .ds-summary:visible");
		let needsViewMoreLink = false;
		try {
			const renderedHeight = $(dsSummary)[0].clientHeight;
			const fullHeight = $(dsSummary)[0].scrollHeight;
			needsViewMoreLink =  fullHeight > renderedHeight;
		} catch (error) {
			// just rely on false value for needsViewMoreLink
		}

		if (needsViewMoreLink) {
			const viewMoreHtml = "<div class='ds-summery-view-more'><button class='view-more-link'>View More</button></div>";
			$(viewMoreHtml).insertAfter($(dsSummary));
			$(".product-summary .ds-summery-view-more .view-more-link").on("click", function() {
				DatasheetSummary.showDsSummaryModal();
			});
		}
	}

	private static populateDsSummaryModal() {
		const summary = $("#ds-summary");
		const summaryHtml = $(summary).html();

		const descriptionModal = $("#ds-summary-dialog");
		$(descriptionModal).find(".description").html(summaryHtml);
	}

	private static showDsSummaryModal() {
		this.populateDsSummaryModal();
		const scrollTop = ((window.scrollY  !== undefined) ? window.scrollY : document.body.scrollTop) + 25;
		$('#ds-summary-dialog').css("top", scrollTop + "px");
		$('#ds-summary-dialog, #sitewide-overlay').fadeIn();
	}

}